// extracted by mini-css-extract-plugin
module.exports = {"container":"MultiSelect__container--17G","button":"MultiSelect__button--mwu"};